import React from "react";
import CalendlyButton from "../components/CalendlyButton";
import ProfileCard from "../components/ProfileCard";
import CustomerReviews from "../components/CustomerReviews";
import { Link } from "react-router-dom";
import Timeline from "../components/Timeline";
import FAQSection from "../components/FAQSection";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";


const AboutUsPage = () => {


        const location = useLocation();

        useEffect(() => {
            if (location.hash === "#faq") {
                const el = document.getElementById("faq");
                if (el) {
                    el.scrollIntoView({ behavior: "smooth" });
                }
            }
        }, [location]);

        return (
            <div className="bg-white">
                {/* Intro Section */}
                <section className="py-20 px-6 bg-white">
                    <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-start gap-12">
                        <ProfileCard
                            image="/amit-vishnoi.png"
                            name="Amit Vishnoi"
                            title="Director & Buyer's Agent"
                        />

                        <div className="w-full lg:w-2/3">
                            <h1 className="text-4xl font-bold text-[#003366] mb-6">About Us</h1>
                            <p className="text-[#003366] text-lg leading-relaxed mb-4">
                                National Property Consultant is not just a buyer's agency — it's a mission to help busy professionals, first-time investors, and SMSF buyers build wealth through strategic property investment.
                            </p>
                            <p className="text-gray-700 text-md leading-relaxed mb-4">
                                Founded by <strong>Amit Vishnoi</strong>, our team brings years of on-the-ground experience, deep market knowledge, and a proven framework that helps you make smarter decisions — from search to settlement and beyond.
                            </p>
                            <p className="text-gray-700 text-md leading-relaxed mb-4">
                                With an ethical, transparent, and client-first approach, we help you buy properties with strong rental yields, future capital growth, and minimal stress.
                            </p>
                            <ul className="list-disc pl-5 text-gray-700 space-y-2 mb-6">
                                <li>End-to-end buyer’s agency services</li>
                                <li>Deep experience in SMSF & Trust purchases</li>
                                <li>Strategic planning tailored to your goals</li>
                                <li>Support for both investors and other buyer’s agents</li>
                            </ul>
                            <CalendlyButton buttonText="Book a Free Discovery Call" />
                        </div>
                    </div>
                </section>

                {/* Our Values */}
                <section className="py-20 px-6 bg-[#f9f9f9]">
                    <div className="max-w-5xl mx-auto text-center">
                        <h2 className="text-3xl font-bold text-[#003366] mb-10">Our Values</h2>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-gray-700 text-md">
                            {[
                                { title: "Integrity", desc: "We do what’s right — not what’s easy — in every transaction." },
                                { title: "Transparency", desc: "Open communication and honesty at every stage of the journey." },
                                { title: "Results-Driven", desc: "We’re focused on helping you build long-term, profitable portfolios." },
                            ].map((val, idx) => (
                                <div key={idx} className="bg-white p-6 rounded-lg shadow-sm">
                                    <h3 className="text-[#003366] font-semibold mb-2">{val.title}</h3>
                                    <p>{val.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Timeline */}

                <Timeline />


                <FAQSection />


                {/* Reviews & CTA */}
                <section className="py-20 px-6 bg-[#f9f9f9]">
                    <h2 className="text-3xl font-bold text-[#003366] text-center mb-10">What Our Clients Say</h2>
                    <CustomerReviews />
                    <div className="text-center mt-10">
                        <Link
                            to="/case-studies"
                            className="inline-block bg-[#fbb40b] hover:bg-[#da3e13] text-white font-semibold py-3 px-6 rounded-full shadow-md transition"
                        >
                            View Our Case Studies
                        </Link>
                    </div>
                </section>
            </div>
        );
    };

    export default AboutUsPage;
